export default __webpack_public_path__ + "static/media/image 71.5ffdae67.webp";